import axios from 'axios';
import Button from '@/components/Button';
import { 
   PersonAddAlt as AssignIcon
} from '@mui/icons-material';

import { getErrorMessage } from '@/utils/Errors';

export default function TicketsButtons({t,user,language,api,apiUrl,token,handleLogin,sendMessage}){

    const handleButtonAssign = () => {

        // check if selected elements
        const selectedNodes = api.getSelectedNodes();
            
        if(!selectedNodes || selectedNodes.length === 0){        
            sendMessage(t('actions.select.empty',{item:t('tickets.menu.title')}),'error');
        }
        else{

            // get selected ids
            const ids = [];
            selectedNodes?.forEach((node) => {
                ids.push(node?.data?.id);
            });

            var apiPath = '/tickets/assign';

            const config = {
                headers: { Authorization: `Bearer ${token}` } 
            };

            const userId = parseInt(user?.id);

            const send = {
                language: language,
                companyuser: user?.company,
                ids: ids?.join(','),
                user: userId
            };

            var errorMessage = t('tickets.update.error');            

            axios.put(apiUrl+apiPath,send,config)
            .then(function (response) {
                
                if(response?.data){
              
                    var responseData = response.data;

                    // if result is ok (1)                
                    if(responseData?.result){              
                        
                        sendMessage(t('tickets.assigned.success'));

                        // update nodes
                        const updatedNodes = [];
                        selectedNodes?.forEach((node) => {
                            const updatedData = node?.data;
                            updatedData.assigned = userId;
                            updatedNodes.push(updatedData);
                        });
                                                
                        api?.applyTransaction({
                            "update": updatedNodes
                        });
                    } 
                    else{

                        if(responseData?.status && responseData.status === 401){
                            handleLogin();
                        }
                        else{                       
                            // check error message
                            if(responseData?.data?.reasons){                            
                                const reasons = responseData?.data?.reasons;
                                errorMessage = getErrorMessage(t,'tickets',reasons);
                            }
                            
                            sendMessage(errorMessage,'error');
                        }
                    }
                }
                else{
                    sendMessage(errorMessage,'error');   
                }
            })
            .catch(function (error){
                
                if(error?.status && error.status === 401){
                    handleLogin();
                }
                else{                    
                    sendMessage(errorMessage,'error');
                }
            });
        }
    }

    return (
        <div className='flex justify-center items-center w-full max-md:grid max-md:grid-cols-12 my-4'>
            <div className={'mx-1 max-md:my-1 max-md:col-span-12 max-md:text-center'}>
                <Button            
                    onClick={handleButtonAssign}
                    type="edit"
                    icon={<AssignIcon/>}
                />
            </div>
        </div>
    );
}